export const option = () => {
  return {
    noDataLoadingOption: {
      text: '暂无数据',
      effect: 'bubble',
      effectOption: {
        effect: {
          n: 0
        }
      }
    },

    tooltip: {
      /* 提示框*/
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }/*, formatter: function (value) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引




      }*/
    },
    toolbox: {
      /*工具箱*/
      zlevel: 0, // 所属图形的Canvas分层，zlevel 大的 Canvas 会放在 zlevel 小的 Canvas 的上面
      z: 2, // 所属组件的z分层，z值小的图形会被z值大的图形覆盖
      left: 'right', // 组件离容器左侧的距离,'left', 'center', 'right','20%'
      top: 'top', // 组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
      right: '20%', // 组件离容器右侧的距离,'20%'
      bottom: 'auto', // 组件离容器下侧的距离,'20%'
      width: 'auto', // 图例宽度
      height: 'auto',
      feature: {
        /* dataView: {show: true, readOnly: false},*/
        /* dataView: { // 数据视图工具，可以展现当前图表所用的数据，编辑后可以动态更新
           show: true, // 是否显示该工具。
           title: '数据视图',
           iconStyle: {
             borderColor: '#F8AD34'
           },
           readOnly: false, // 是否不可编辑（只读）
           lang: ['数据视图', '关闭', '刷新'], // 数据视图上有三个话术，默认是['数据视图', '关闭', '刷新']
           backgroundColor: '#fff', // 数据视图浮层背景色。
           textareaColor: '#fff', // 数据视图浮层文本输入区背景色
           textareaBorderColor: '#333', // 数据视图浮层文本输入区边框颜色
           textColor: '#000', // 文本颜色。
           buttonColor: '#c23531', // 按钮颜色。
           buttonTextColor: '#fff' // 按钮文本颜色。
         },*/
        magicType: {
          show: true, type: ['bar', 'line'], iconStyle: {
            borderColor: '#009BAC'
          },
        }, /*设置可切换的图表类型。目前支持的只有4种，line折线图、bar柱状图、stack堆叠模式、tiled平铺模式*/
        restore: {show: true, iconStyle: {borderColor: '#F1511B'}},
        dataZoom: { // 数据区域缩放。目前只支持直角坐标系的缩放
          show: true, // 是否显示该工具。
          title: '缩放', // 缩放和还原的标题文本
          xAxisIndex: 0, // 指定哪些 xAxis 被控制。如果缺省则控制所有的x轴。如果设置为 false 则不控制任何x轴。如果设置成 3 则控制 axisIndex 为 3 的x轴。如果设置为 [0, 3] 则控制 axisIndex 为 0 和 3 的x轴
          yAxisIndex: false, // 指定哪些 yAxis 被控制。如果缺省则控制所有的y轴。如果设置为 false 则不控制任何y轴。如果设置成 3 则控制 axisIndex 为 3 的y轴。如果设置为 [0, 3] 则控制 axisIndex 为 0 和 3 的y轴
          iconStyle: {borderColor: '#4774BF'}
        }, saveAsImage: {show: true, title: '保存', iconStyle: {borderColor: '#E88678'}}

      }/*,
      iconStyle: {
        /!*color: 自适应,*!/
        borderColor: '#fa131b',
        borderWidth: 1,
        borderType: 'solid', /!*
        shadowBlur: ...,*!/
        shadowColor: ['#325dee','fa131b'],
        shadowOffsetX: 0,
        shadowOffsetY: 0/!*,
        opacity: ...,
        textPosition: ...,
        textAlign: ...,*!/
      }*/
    },
    legend: {
      orient: 'horizontal',
      type: 'scroll',
      top: '8%',
      right: '0%',
      data: []
    },
    grid: {
      top: '16%',
      left: '5%',
      right: '0%',
      bottom: '14%',
      containLabel: false
    },
    xAxis: [
      {
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#999'//左边线的颜色
          }
        },
        axisLabel: { // 坐标轴刻度标签的相关设置
          show: true, // 是否显示
          interval: 'auto', // 坐标轴刻度标签的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
          inside: false, // 刻度标签是否朝内，默认朝外
          rotate: 0, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。旋转的角度从 -90 度到 90 度
          margin: 8, // 刻度标签与轴线之间的距离
          formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
            return value
          }/*,
          textStyle: {
            color: 'black'
          }*/,
          showMinLabel: null, // 是否显示最小 tick 的 label。可取值 true, false, null。默认自动判定（即如果标签重叠，不会显示最小 tick 的 label）
          showMaxLabel: null, // 是否显示最大 tick 的 label。可取值 true, false, null。默认自动判定（即如果标签重叠，不会显示最大 tick 的 label）
          data: []
        },

        /*splitLine: { // 坐标轴在 grid 区域中的分隔线。
          show: true, // 是否显示分隔线。默认数值轴显示，类目轴不显示。
          interval: 'auto'
        },*/ /*,
        splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
          interval: 'auto',
          show: true
        }*/
        axisTick: { // 坐标轴刻度相关设置
          show: true, // 是否显示坐标轴刻度。
          alignWithLabel: false, // 类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
          interval: 'auto', // 坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
          inside: false, // 坐标轴刻度是否朝内，默认朝外。
          length: 5 // 坐标轴刻度的长度。

        },
        show: true,
        size: 10,
        type: 'category',
        data: [/* '暂','无','数','据'*/],
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#999'//左边线的颜色
          }
        },
        type: 'value',
        name: '',
        axisLabel: {
          formatter: function (value, index) { // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + "K";
            } else if (value >= 1000000 && value < 1000000000) {
              value = value / 1000000 + "M";
            } else if (value >= 1000000000) {
              value = value / 1000000000 + "B";
            } else if (value <= -1000 && value > -1000000) {
              value = value / 1000 + "K";
            } else if (value <= -1000000 && value > -1000000000) {
              value = value / 1000000 + "M";
            } else if (value <= -1000000000) {
              value = value / 1000000000 + "B";
            }
            return value;
          }/*
          formatter: '{value} 次'*/
        },
        minInterval: 1,
        splitLine: { // 坐标轴在 grid 区域中的分隔线。
          show: true, // 是否显示分隔线。默认数值轴显示，类目轴不显示。
          interval: 'auto',
          lineStyle: {
            type: 'dashed',
            color: '#999'
          }
        }
      }
    ],
    series: [
      {
        name: [],
        type: 'line',
        yAxisIndex: 0,
        data: [],
        itemStyle: {
          normal: {
            //好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了，
            color: function (params) {
              // build a color map as your need.
              let colorList = [
                '#C1232B', '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0'
              ];
              return colorList[params.dataIndex]
            }
          }
        },
        smooth: true/*true平滑曲线 false基本折线*/
      }
    ]
  }
}

function tableStringToFixed(row, column, cellValue) { // 表格中字符串格式化
  if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
    let rs = cellValue.toString().indexOf('.');
    if (rs < 0) {
      cellValue += '.00';
    }
    else {
      cellValue = cellValue.toFixed(2)
    }
    return cellValue;
  }
  return '--'
}
